export default __webpack_public_path__ + "static/media/arrows.5665add2.gif";